import { MonitoringAreaSegmentCollapsible } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/assessment/_components/monitoring-area-segment-component";
import { RequirementArea } from "@/services/backend/qpm/requirements/types/requirement";
import { RequirementDTO } from "@/services/backend/qpm/requirements/types/requirement-dto";

export type AreaMonitorWrapperProps = {
  requirement: RequirementDTO;
  selectedAreas: RequirementArea[];
  buildingName?: string;
  levelName?: string;
};

export function MonitoringAreas({
  requirement,
  selectedAreas,
  buildingName = "",
  levelName = "",
}: AreaMonitorWrapperProps) {
  return (
    selectedAreas.length > 0 && (
      <div className="border">
        {[...selectedAreas]
          .sort((a, b) => {
            const dateA = new Date(a.createdAt).getTime();
            const dateB = new Date(b.createdAt).getTime();
            return dateA - dateB;
          })
          .map((ra: RequirementArea, index: number) => (
            <MonitoringAreaSegmentCollapsible
              requirement={requirement}
              index={index + 1}
              key={ra.area.base.id}
              area={ra}
              buildingName={buildingName!}
              levelName={levelName!}
            />
          ))}
      </div>
    )
  );
}
